export default {
  moneySymbol: '₴',
  deleteThisLine: 'Видатили рядок',
  copyThisLine: 'Скопіювати рядок',
  form: {
    lightFilter: {
      more: 'Ще',
      clear: 'Очистити',
      confirm: 'Ок',
      itemUnit: 'Позиції'
    }
  },
  tableForm: {
    search: 'Пошук',
    reset: 'Очистити',
    submit: 'Відправити',
    collapsed: 'Розгорнути',
    expand: 'Згорнути',
    inputPlaceholder: 'Введіть значення',
    selectPlaceholder: 'Оберіть значення'
  },
  alert: {
    clear: 'Очистити',
    selected: 'Обрано',
    item: 'елементів'
  },
  pagination: {
    total: {
      range: ' ',
      total: 'з',
      item: 'елементів'
    }
  },
  tableToolBar: {
    leftPin: 'Закріпити зліва',
    rightPin: 'Закріпити справа',
    noPin: 'Відкріпити',
    leftFixedTitle: 'Закріплено зліва',
    rightFixedTitle: 'Закріплено справа',
    noFixedTitle: 'Не закріплено',
    reset: 'Скинути',
    columnDisplay: 'Відображення стовпців',
    columnSetting: 'Налаштування',
    fullScreen: 'Повноекранний режим',
    exitFullScreen: 'Вийти з повноекранного режиму',
    reload: 'Оновити',
    density: 'Розмір',
    densityDefault: 'За замовчуванням',
    densityLarger: 'Великий',
    densityMiddle: 'Середній',
    densitySmall: 'Стислий'
  },
  stepsForm: {
    next: 'Наступний',
    prev: 'Попередній',
    submit: 'Завершити'
  },
  loginForm: {
    submitText: 'Вхіх'
  },
  editableTable: {
    onlyOneLineEditor: 'Тільки один рядок може бути редагований одночасно',
    action: {
      save: 'Зберегти',
      cancel: 'Відмінити',
      delete: 'Видалити',
      add: 'додати рядок'
    }
  },
  switch: {
    open: 'Відкрито',
    close: 'Закрито'
  }
};